import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./features/auth/useAuth";
import { RequireAuth } from "./features/auth/RequireAuth";
import { AdminHrDashboardPage } from "./features/dashboard/AdminHrDashboardPage";
import { EmployeeDashboardPage } from "./features/dashboard/EmployeeDashboardPage";
import { GateDashboardPage } from "./features/dashboard/GateDashboardPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PublicBadgePage } from "./pages/PublicBadgePage";
import { PublicInvitePage } from "./pages/PublicInvitePage";
import { GateSelfRegisterPage } from "./pages/GateSelfRegisterPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { UnauthorizedPage } from "./pages/UnauthorizedPage";
import "./App.css";

function HomeRedirect() {
  const { isAuthenticated, dashboardPath } = useAuth();
  return <Navigate to={isAuthenticated ? dashboardPath : "/login"} replace />;
}

function DashboardRedirect() {
  const { dashboardPath } = useAuth();
  return <Navigate to={dashboardPath} replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<DashboardRedirect />} />
      </Route>

      <Route element={<RequireAuth allowedRoles={["gate"]} />}>
        <Route path="/dashboard/gate" element={<GateDashboardPage />} />
      </Route>

      <Route element={<RequireAuth allowedRoles={["admin-hr"]} />}>
        <Route path="/dashboard/admin-hr" element={<AdminHrDashboardPage />} />
      </Route>

      <Route element={<RequireAuth allowedRoles={["employee"]} />}>
        <Route path="/dashboard/employee" element={<EmployeeDashboardPage />} />
      </Route>

      <Route path="/visit/:token" element={<PublicInvitePage />} />
      <Route path="/gate/:token" element={<GateSelfRegisterPage />} />
      <Route path="/badge/:badgeCode" element={<PublicBadgePage />} />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
